import { BsArrowLeftShort, BsArrow90DegLeft } from "react-icons/bs";
import ProfilePic from "./ProfilePic";

type Props = {
  setShowMessages: (e: boolean) => void;
  messageDetails?: any;
  onShow: () => void;
};

function MessageContent({ setShowMessages, messageDetails, onShow }: Props) {
  return (
    <div>
      <div className="heading">
        <div onClick={() => setShowMessages(true)}>
          <BsArrowLeftShort className="left-arrow" />
        </div>
        <h5>{messageDetails?.sub}</h5>
      </div>
      {messageDetails?.messages?.map((items: any) => (
        <div key={items?._id}>
          <div>
            <div className="heading">
              <div className="me-2">
                <ProfilePic email={items?.from} />
              </div>
              <div>
                <span className="me-2">{items?.from}</span>
                <span>
                  <span aria-hidden="true">&lt;</span>
                  {items?.userName}
                  <span aria-hidden="true">&gt;</span>
                </span>
              </div>
            </div>
            <div
              className="ms-5"
              dangerouslySetInnerHTML={{
                __html: items?.msg,
              }}
            />
            <div className="w-100 d-flex flex-wrap ms-5 mt-5">
              {items?.docs?.map((file: any, index: any) => (
                <div
                  key={index}
                  className="d-flex gap-5 justify-content-between align-items-center selectedFile"
                >
                  <a
                    href={file.data} // This is the base64 string
                    download={file.name} // Set the name for the downloaded file
                    style={{ textDecoration: "none", color: "black" }} // Optional styling
                  >
                    {file.name}
                  </a>
                </div>
              ))}
            </div>
          </div>
          <hr />
        </div>
      ))}
      <div className="ms-5 mt-4">
        <button className="primary-button" onClick={onShow}>
          <BsArrow90DegLeft className="me-2" /> Reply
        </button>
      </div>
    </div>
  );
}

export default MessageContent;
